function customizeError(data) {
  const errors = Object.keys(data.errors);
  const message = errors
    .map((el) => {
      return data.errors[el][0];
    })
    .join(' ');
  return message;
}

export function getErrorMsg(err) {
  if (!err.response) {
    return err.message;
  } else {
    return err.response.data.message;
  }
}
export default customizeError;
